// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function from_string(status) {
  switch (status) {
    case "active" :
        return /* Active */0;
    case "inactive" :
        return /* InActive */1;
    default:
      return ErrorUtils$Catalyst.raiseError("PartnerActiveStatusFilter.re", "Invalid active_status type", status);
  }
}

function to_string(value) {
  if (value) {
    return "inactive";
  } else {
    return "active";
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), from_string);
}

var lst = {
  hd: /* Active */0,
  tl: {
    hd: /* InActive */1,
    tl: /* [] */0
  }
};

export {
  from_string ,
  to_string ,
  t_decode ,
  lst ,
  
}
/* No side effect */
